<div class="jacketart pointer" tabindex="0" (agInteract)="goToFullRecord(carouselItem)">
  <img
    class="max-height-100 max-width-80"
    [alt]="carouselItem.title"
    [src]="carouselItem.jacketArt.large"
    [title]="carouselItem.title"
    onerror="this.onerror=null;this.alt='Image not available';this.src='https\:\/\/www5.auto-graphics.com/v6assets/no-image-foundlrg.png?local'"
  />
</div>
<div class="slide-content pointer">
  <div class="mat-body-strong">{{ carouselItem.title }}</div>
  <div class="mat-caption">
    <div>{{ carouselItem.author }}</div>
    <div>{{ carouselItem.publisher }}</div>
    <div>{{ carouselItem.format?.long }}</div>
    <div>{{ carouselItem.pubYear }}</div>
    @if (showCallNumber) {
      <div>{{ carouselItem.callNumber }}</div>
    }
  </div>
  <div class="mat-body-strong">Holds: {{ carouselItem.totalHolds }}</div>
  <div class="mat-body-strong">
    Availability: {{ carouselItem.totalAvailables }} of {{ carouselItem.totalCopies }}
  </div>
</div>
<ng-content></ng-content>
